import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";

function Offer3NiwelacjaTerenu() {
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/niwelacja-terenu-2-1.jpeg"
          alt="Niwelacja terenu - wyrównanie działki - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Niwelacja terenu pod zakładanie ogrodu i trawnika Gdańsk, Kaszuby
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Kształtowanie skarp i idealne przygotowanie gleby pod zieleń
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Przed posianiem trawy lub ułożeniem rolek w ogrodzie na terenie Gdańska, Gdyni, Wejherowa i Kartuz niezbędne jest perfekcyjne wyprofilowanie podłoża. Realizujemy niwelację terenu pod ogrody, usuwamy chwasty, nawozimy żyzną ziemię i kształtujemy spadek odprowadzający wodę opadową. Dobrze zniwelowana działka gwarantuje, że <a href="/zakladanie-ogrodu/kompleksowo" className="underline hover:opacity-80">założony ogród</a> będzie zachwycał przez dekady.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Gdzie sprawdzi się niwelowanie terenu?
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Na czym polega niwelacja terenu?
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Czy do założenia trawnika potrzebna jest niwelacja?
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Ile kosztuje niwelacja terenu?
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Gdzie sprawdzi się niwelowanie terenu?</h2>
          <p>
            Przy zakładaniu nowego ogrodu prawidłowe ukształtowanie terenu to klucz do sukcesu. Rzadko zdarza się, aby naturalne podłoże było idealnie przygotowane pod wysiew roślin czy budowę ścieżek, dlatego profesjonalne wyrównanie gruntu ułatwia wszystkie dalsze prace ogrodnicze.
          </p>
          <p>
            Płaskie podłoże zapobiega spływaniu i wypłukiwaniu nasion roślin oraz nawozów podczas deszczu. Odpowiednie ukształtowanie terenu w ogrodzie podnosi też estetykę całej posesji, nadając jej uporządkowany, nowoczesny charakter.
          </p>
          <p>
            Podczas niwelacji pod ogród wyznaczamy też rzędne wysokościowe pod architekturę ogrodową, tarasy czy wiaty grillowe, dbając o to, by nadmiar wody deszczowej odpływał w bezpieczne, wyznaczone strefy chłonne.
          </p>
          <p>
            Dokładne wypoziomowanie gruntu jest niezbędny również w strefie rekreacyjnej – np. pod basen ogrodowy czy plac zabaw dla dzieci, co gwarantuje bezpieczeństwo ich użytkowania.
          </p>

          <p>Prace przygotowawcze, które dla Ciebie wykonamy:</p>
          <ul>
            <li>niwelacja terenu pod trawnik</li>
            <li>niwelacja terenu pod ogród</li>
            <li>wyrównanie terenu pod budowę</li>
            <li>równanie działki po budowie</li>
            <li>przygotowanie terenu pod oczko wodne</li>
            <li>równanie terenu pod taras</li>
            <li>przygotowanie terenu pod basen</li>
          </ul>

          <h2 id="2">Na czym polega niwelacja terenu?</h2>
          <p>
            Niwelowanie terenu w ujęciu ogrodniczym polega na usunięciu wierzchniej warstwy darniny, zlikwidowaniu dołków i garbów, a także nawiezieniu i rozplantowaniu świeżej, żyznej ziemi ogrodowej pod roślinność ozdobną.
          </p>
          <p>
            Nasi projektanci pomogą zaplanować odpowiednie strefy i różnice poziomów w Twoim ogrodzie. Tworzymy estetyczne wzniesienia pod skalniaki oraz obniżenia terenu, które nadają przestrzeni unikalną dynamikę i głębię.
          </p>

          <h2 id="3">Czy do założenia trawnika potrzebna jest niwelacja?</h2>
          <p>
            Zadbana murawa wymaga idealnie równego podkładu. Pozwala to na jednolite koszenie trawy bez "łysych placków" powstających przy przejechaniu kosiarką przez muldy i nierówności.
          </p>
          <p>
            Staranne przygotowanie podłoża decyduje o zakorzenieniu się trawników z siewu oraz z rolki. Samodzielne grabienie i wałowanie bywa bardzo żmudne, dlatego najlepiej powierzyć to profesjonalnej glebogryzarce separacyjnej i minikoparce.
          </p>
          <p>
            Użycie specjalistycznego sprzętu ogrodniczego daje znacznie lepsze rezultaty niż praca ręczna. Po zniwelowaniu gruntu możemy kompleksowo wykonać zasiew lub rozłożyć gotową trawę w rolkach.
          </p>

          <h2 id="4">Ile kosztuje niwelacja terenu?</h2>
          <p>
            Koszt przygotowania i wyrównania gruntu pod ogród zależy od stopnia nachylenia terenu, konieczności dowozu żyznej ziemi oraz wielkości działki. Zapraszamy do przesłania zapytania za pomocą formularza na stronie – chętnie sporządzimy darmową wycenę oraz doradzimy najlepsze rozwiązania.
          </p>
          <p>
            Odezwij się do nas i zrób pierwszy krok w stronę pięknego, harmonijnego ogrodu. Gwarantujemy rzetelne wykonanie prac oraz pełne zadowolenie z uzyskanego efektu.
          </p>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/niwelacjaterenu-0.jpeg"
              alt="Niwelacja terenu - realizacja Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-3">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/niwelacjaterenu-1.jpeg"
              alt="Niwelacja terenu - realizacja Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/niwelacjaterenu-3.jpeg"
              alt="Niwelacja terenu - realizacja Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/niwelacjaterenu-4.jpeg"
              alt="Niwelacja terenu - realizacja Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/niwelacjaterenu-5.jpeg"
              alt="Niwelacja terenu - realizacja Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-5">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/niwelacja-terenu-1-1.jpeg"
              alt="Niwelacja terenu - realizacja Drzewus nr 6"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Offer3NiwelacjaTerenu;
